import { Component } from '@angular/core';

@Component({
  selector: 'app-deactivate-dialog',
  templateUrl: './deactivate-dialog.component.html',
  styleUrls: ['./deactivate-dialog.component.scss'],
  standalone: false
})
export class DeactivateDialogComponent {}
